// src/use-id-compatibility.ts
import React from "react";
var useLegacyCustomId = () => React.useMemo(() => Math.random().toString(36).substring(7), []);
var _a;
var useIdCompatibility = (_a = React.useId) != null ? _a : useLegacyCustomId;

// src/use-start-transition-compatibility.ts
import React3 from "react";

// src/use-transition-compatibility.ts
import React2 from "react";
var useTransitionCompatibility = () => {
  var _a2, _b;
  const result = (_b = (_a2 = React2).useTransition) == null ? void 0 : _b.call(_a2);
  if (result) {
    return result;
  }
  const fallbackStartTransition = callback => {
    setTimeout(callback, 0);
  };
  return [false, fallbackStartTransition];
};

// src/use-start-transition-compatibility.ts
var useStartTransitionCompatibility = () => {
  const isStartTransitionAvailable = typeof React3.startTransition === "function";
  const [isPending, startTransition] = useTransitionCompatibility();
  const runTransition = callback => {
    if (isStartTransitionAvailable) {
      startTransition(() => {
        callback();
      });
    } else {
      setTimeout(() => {
        callback();
      }, 0);
    }
  };
  return [isPending, runTransition];
};
export { useIdCompatibility, useLegacyCustomId, useStartTransitionCompatibility };